<template>
  <div>
    <span v-for="(attributeValue, attributeKey) in filtered_row_properties.attributes" :key="attributeKey">
      <span><strong class="key">{{ attributeKey | key_transform }} : </strong></span>
      <span> {{ attributeValue }}</span><br>
    </span>
    <span v-if="rowProperties.attributes.feed">
      <strong class="key">Feed : </strong><a :href="`feeds/${rowProperties.attributes.feed.uuid}/edit`">{{ rowProperties.attributes.feed.name }}</a>
    </span>
    <span v-if="rowProperties.attributes.item">
      <strong class="key">Item : </strong><a :href="`feeds/${rowProperties.attributes.item.uuid}/edit`">{{ rowProperties.attributes.item.name }}</a>
      <br>
    </span>
    <span v-if="rowProperties.attributes.artwork">
      <strong class="key">Item : </strong>{{ rowProperties.attributes.artwork.name }}
      <br>
    </span>
  </div>
</template>

<script>
import PropertiesMixin from "VueMixins/ActivityLog/PropertiesMixin";

export default {
  mixins: [PropertiesMixin],
  props: {
    rowProperties: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .key {
    text-transform: capitalize;
  }
</style>
